import {
  CcfAlert,
  CcfBox,
  CcfButton,
  CcfCloseIcon,
  CcfSnackBar,
  CcfTabs,
  CcfTypography,
  useTranslator,
} from '@nice-ccf/ui-controls';

import styles from './ccf-wem-dashboard.module.scss';
import { Box } from '@mui/material';
import { useState } from 'react';
import { CcfWemCoachingSessionsTab } from './ccf-wem-coaching-sessions-tab';
import { CcfWemCoachingRequestTab } from './ccf-wem-coaching-request-tab';
import { CcfWemSelectedSession } from './ccf-wem-selected-session';
import { CcfWemRequestCoachingDialog } from './ccf-wem-request-coaching-dialog';

/* eslint-disable-next-line */
export interface CcfWemCoachingSessionsProps {}

/**
 * CcfWemCoaching - used to display wem coaching
 * @param props - CcfWemCoaching
 * @example `<CcfWemCoaching />`
 */
export function CcfWemCoachingSessions(props: CcfWemCoachingSessionsProps) {
  const [translate] = useTranslator();
  const [isSessionSelected, setisSessionSelected] = useState(false);
  const [selectedSession, setSelectedSession] = useState({});
  const [isRequestClicked, setIsRequestClicked] = useState(false);
  const [requestRowData, setRequestRowData] = useState([]);
  const [showToast, setShowToast] = useState(false);

  const coachingTabs = [
    {
      element: (
        <CcfWemCoachingSessionsTab
          setisSessionSelected={setisSessionSelected}
          isSessionSelected={isSessionSelected}
          selectedSession={selectedSession}
          setSelectedSession={setSelectedSession}
        />
      ),
      isActive: true,
      menuName: translate('CoachingSessions'),
      id: 0,
    },
    {
      element: (
        <CcfWemCoachingRequestTab
          isRequestClicked={isRequestClicked}
          setIsRequestClicked={setIsRequestClicked}
          requestRowData={requestRowData}
        />
      ),
      isActive: false,
      menuName: translate('CoachingRequests'),
      id: 1,
    },
  ];
  const [currentTab, setCurrentTab] = useState(0);

  /**
   * Used to update the app space tab menuName and tab index
   * @param newTabIndex - number
   * @example - handleChange(0)
   */
  const handleChange = (newTabIndex: number) => {
    setCurrentTab(newTabIndex);
  };

  return (
    <CcfBox className={styles.wemSessionMainContainer}>
      {!isSessionSelected ? (
        <>
          <CcfBox
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '5px',
            }}
          >
            <CcfTypography className={styles.wemSessionTabTitle}>
              {translate('CoachingSessions')}
            </CcfTypography>
            <CcfButton
              primary
              style={{
                padding: '.5rem .938rem',
                height: '2.2rem',
                fontSize: '0.8rem',
              }}
              onClick={() => setIsRequestClicked(true)}
            >
              {translate('RequestCoaching')}
            </CcfButton>
          </CcfBox>
          <CcfBox className={styles.wemSessionParentContainer}>
            <CcfBox
              id="agent_wemSessionsTabContainer"
              style={{
                height: 'calc(100% - 33px)',
              }}
            >
              <CcfTabs
                currentTab={currentTab}
                // textColor={'#005C99'}
                variant={CcfTabs.Variant.STANDARD}
                setCurrentTab={handleChange}
                classes={{
                  root: styles.tabsContainer,
                }}
                id={`agent_coachingSessions_${currentTab}_tab`}
              >
                {coachingTabs.map((tab, index) => (
                  <CcfTabs.TabPanel key={index} label={tab.menuName}>
                    <Box
                      id={`agent_coachingSessions_${tab.element}_tab`}
                      style={{ height: 'calc(100% - 40px)' }}
                    >
                      {tab.element}
                    </Box>
                  </CcfTabs.TabPanel>
                ))}
              </CcfTabs>
            </CcfBox>
          </CcfBox>
        </>
      ) : (
        <CcfWemSelectedSession
          setisSessionSelected={setisSessionSelected}
          isSessionSelected={isSessionSelected}
          selectedSession={selectedSession}
        />
      )}
      {isRequestClicked && (
        <CcfWemRequestCoachingDialog
          setIsRequestClicked={setIsRequestClicked}
          isRequestClicked={isRequestClicked}
          requestRowData={requestRowData}
          setRequestRowData={setRequestRowData}
          setCurrentTab={setCurrentTab}
          setShowToast={setShowToast}
        />
      )}
      <CcfBox>
        <CcfSnackBar
          open={showToast}
          autoHideDuration={3000}
          onClose={() => {
            setShowToast(false);
          }}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
        >
          <div>
            <CcfAlert
              closeAlert={() => {
                setShowToast(false);
              }}
              severity="success"
            >
              {'Coaching request sent successfully.'}
            </CcfAlert>
          </div>
        </CcfSnackBar>
      </CcfBox>
    </CcfBox>
  );
}
